export default "<div class=\"main-wrap\">\n    <router-outlet></router-outlet>\n</div>"